module.exports = __webpack_public_path__ + "img/addUser.60b3078d.png";